import { OptionalTimeZone } from '../../timezones'
import {
  ExtendedTemplateItemOptions,
  FilenameTemplateItem,
} from './FilenameTemplateItem'

type AsphaltLot = {
  testedDate: Date | null
  createdDate: Date | null
  asphaltLotId: string | null
}
export class AsphaltLotFilenameTemplateItem<
  Property extends keyof AsphaltLot,
  ID extends Lowercase<string>
> extends FilenameTemplateItem<AsphaltLot, 'AsphaltLot', Property, ID> {
  value<T extends AsphaltLot>(
    record: T | null | undefined,
    tz: OptionalTimeZone
  ): string {
    if (this.property === 'asphaltLotId')
      return this.resolve(record?.asphaltLotId)
    return this.resolveDate(record?.testedDate ?? record?.createdDate, tz)
  }
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(options: ExtendedTemplateItemOptions<AsphaltLot, Property, ID>) {
    super({ classType: 'AsphaltLot', ...options })
  }
}

type AsphaltMixDesign = {
  mixDesignNumber: string | null
  grade: string | null
}
export class AsphaltMixDesignFilenameTemplateItem<
  Property extends keyof AsphaltMixDesign,
  ID extends Lowercase<string>
> extends FilenameTemplateItem<
  AsphaltMixDesign,
  'AsphaltMixDesign',
  Property,
  ID
> {
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(
    options: ExtendedTemplateItemOptions<AsphaltMixDesign, Property, ID>
  ) {
    super({ classType: 'AsphaltMixDesign', ...options })
  }
}

type AsphaltMaterial = {
  placementType: string | null
  shortName: string | null
}
export class AsphaltMaterialFilenameTemplateItem<
  Property extends keyof AsphaltMaterial,
  ID extends Lowercase<string>
> extends FilenameTemplateItem<
  AsphaltMaterial,
  'AsphaltMaterial',
  Property,
  ID
> {
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(
    options: ExtendedTemplateItemOptions<AsphaltMaterial, Property, ID>
  ) {
    super({ classType: 'AsphaltMaterial', ...options })
  }
}
